module.exports = __webpack_public_path__ + "static/media/fuelman-card.f1c21566.svg";